module.exports = __webpack_public_path__ + "img/bg_o@3x.979dff41.png";